export const dadosIniciaisAcompanhamentoEmTempoReal = {
  estados: {
    antesDeTrabalhar: {
      total: 0,
      funcionarios: []
    },
    aEntrarEmBreve: {
      total: 0,
      funcionarios: []
    },
    emAtraso: {
      total: 0,
      funcionarios: []
    },
    trabalhando: {
      total: 0,
      funcionarios: []
    },
    emPausa: {
      total: 0,
      funcionarios: []
    },
    aRetornarEmBreve: {
      total: 0,
      funcionarios: []
    },
    retornoPausaEmAtraso: {
      total: 0,
      funcionarios: []
    },
    aSairEmBreve: {
      total: 0,
      funcionarios: []
    },
    emHoraExtra: {
      total: 0,
      funcionarios: []
    },
    aEstourarLimiteDeHoraExtraEmBreve: {
      total: 0,
      funcionarios: []
    },
    aEstourarLimiteDeHoraExtraEmBreve15min: {
      total: 0,
      funcionarios: []
    },
    realizandoHoraExtraAcimaDoLimiteDefinido: {
      total: 0,
      funcionarios: []
    },
    trabalhou: {
      total: 0,
      funcionarios: []
    },
    faltou: {
      total: 0,
      funcionarios: []
    },
    ausenciaTrabalhada: {
      total: 0,
      funcionarios: []
    },
    emSobreavisoEmBreve: {
      total: 0,
      funcionarios: []
    },
    emSobreaviso: {
      total: 0,
      funcionarios: []
    },
    emHoraExtraDeSobreaviso: {
      total: 0,
      funcionarios: []
    },
    emPausaDeSobreaviso: {
      total: 0,
      funcionarios: []
    },
    completouSobreaviso: {
      total: 0,
      funcionarios: []
    }
  },
  eventos: {
    ausencias: {
      afastamento: {
        total: 0,
        funcionarios: []
      },
      dispensa: {
        total: 0,
        funcionarios: []
      },
      ferias: {
        total: 0,
        funcionarios: []
      },
      folga: {
        total: 0,
        funcionarios: []
      },
      suspensao: {
        total: 0,
        funcionarios: []
      },
      falta: {
        total: 0,
        funcionarios: []
      }
    },
    entradaAdiantada: {
      total: 0,
      funcionarios: []
    },
    entradaNoHorario: {
      total: 0,
      funcionarios: []
    },
    entradaAtrasada: {
      total: 0,
      funcionarios: []
    },
    iniciouPausa: {
      total: 0,
      funcionarios: []
    },
    retornoAdiantado: {
      total: 0,
      funcionarios: []
    },
    retornoNoHorario: {
      total: 0,
      funcionarios: []
    },
    retornoAtrasado: {
      total: 0,
      funcionarios: []
    },
    saidaAdiantada: {
      total: 0,
      funcionarios: []
    },
    saidaNoHorario: {
      total: 0,
      funcionarios: []
    },
    saidaAtrasada: {
      total: 0,
      funcionarios: []
    }
  }
}

export const chavesReferentesAosEstadoTrabalhando = [
  'trabalhando', 'emPausa', 'aRetornarEmBreve', 
  'retornoPausaEmAtraso', 'aSairEmBreve', 'emHoraExtra', 
  'aEstourarLimiteDeHoraExtraEmBreve', 'aEstourarLimiteDeHoraExtraEmBreve15min', 
  'realizandoHoraExtraAcimaDoLimiteDefinido'
]

export const chavesReferentesAHoraExtra = [
  'emHoraExtra', 'aEstourarLimiteDeHoraExtraEmBreve', 
  'aEstourarLimiteDeHoraExtraEmBreve15min', 
  'realizandoHoraExtraAcimaDoLimiteDefinido'
]

export const INDICADOR_IDS = {
  // seleção painel: em atraso ou a iniciar
  EM_ATRASO: 'emAtraso',
  A_INICIAR: 'aIniciar',
  AINDA_NAO_INICIOU: 'aindaNaoIniciou',

  // seleção painel: trabalhando
  TRABALHANDO: 'trabalhando',
  A_RETORNAR_EM_BREVE: 'aRetornarEmBreve',
  RETORNO_PAUSA_EM_ATRASO: 'retornoPausaEmAtraso',
  A_SAIR_EM_BREVE: 'aSairEmBreve',
  ACIMA_DO_LIMITE: 'realizandoHoraExtraAcimaDoLimiteDefinido',
  LIMITE_30: 'aEstourarLimiteDeHoraExtraEmBreve',
  LIMITE_15: 'aEstourarLimiteDeHoraExtraEmBreve15min',
  FORA_DA_JANELA: 'foraDaJanela',
  EM_HORA_EXTRA: 'emHoraExtra',
  ENTRADA_ATRASADA: 'entradaAtrasada',
  EM_PAUSA: 'emPausa',

  // seleção painel: ausentes
  FERIAS: 'ferias',
  DISPENSA: 'dispensa',
  AFASTAMENTO: 'afastamento',
  FALTA: 'faltou',
  JORNADA_ENCERRADA: 'jornadaEncerrada',
  FOLGA: 'folga',
};

export const somarQuantidades = (objeto) => {
  let soma = 0
  for (const chave in objeto) {
    soma += objeto[chave].total
  }
  return soma
}

export const somarQuantidadesSelecionadas = (objeto, chaves) => {
  let soma = 0
  chaves.forEach(chave => {
    if (objeto[chave]) {
      soma += objeto[chave].total
    }
  })
  return soma
}

export const calcularPorcentagem = (parcial, total) => {
  return total === 0 ? 0 : (parcial / total) * 100
}

function converterSnakeCaseParaCamelCase (str) {
  return str.replace(/([-_]\w)/g, g => g[1].toUpperCase())
}

export function converterChavesDeObjeto (obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map(converterChavesDeObjeto)
  }

  return Object.keys(obj).reduce((acc, key) => {
    const camelCaseKey = converterSnakeCaseParaCamelCase(key)
    acc[camelCaseKey] = converterChavesDeObjeto(obj[key])
    return acc
  }, {})
}

export const listaDeFuncionarios = (objeto, chavesDeReferencia) => {
  if (!objeto || !Array.isArray(chavesDeReferencia)) {
    return [];
  }

  return chavesDeReferencia.reduce((funcionariosAcumulados, chave) => {
    const funcionarios = objeto[chave]?.funcionarios || [];
    return [...funcionariosAcumulados, ...funcionarios];
  }, []);
}

export const listaDeFuncionariosComStatus = (objeto, chavesDeReferencia) => {
  if (!objeto || !Array.isArray(chavesDeReferencia)) {
    return [];
  }

  return chavesDeReferencia.reduce((funcionariosAcumulados, chave) => {
    const funcionarios = objeto[chave]?.funcionarios || [];

    const funcionariosComStatus = funcionarios.map(funcionario => ({
      ...funcionario,
      status: chave
    }));
    
    return [...funcionariosAcumulados, ...funcionariosComStatus];
  }, []);
}

const obterSVG = (caminho) => require(`../../../static/${caminho}`);

export const MAPA_INDICADORES = {
  [INDICADOR_IDS.EM_ATRASO]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-falta' 
    },
    classe: 'faltas',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.emAtraso'
  },
  [INDICADOR_IDS.A_INICIAR]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-relogio' 
    },
    classe: 'a-iniciar',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.aIniciar'
  },
  [INDICADOR_IDS.AINDA_NAO_INICIOU]: {
    icone: { tipo: 'class', valor: 'icone-linha-falta' },
    classe: 'faltas',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.aindaNaoIniciou'
  },
  [INDICADOR_IDS.TRABALHANDO]: {
    icone: { 
      tipo: 'image', 
      valor: obterSVG('icones/icone_trabalhando.svg')
    },
    classe: 'trabalhando',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.trabalhando'
  },
  [INDICADOR_IDS.A_RETORNAR_EM_BREVE]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-relogio' 
    },
    classe: 'a-retornar-em-breve',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.aRetornarEmBreve'
  },
  [INDICADOR_IDS.RETORNO_PAUSA_EM_ATRASO]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-pausa' 
    },
    classe: 'retorno-pausa-em-atraso',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.retornoPausaEmAtraso'
  },
  [INDICADOR_IDS.A_SAIR_EM_BREVE]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-relogio' 
    },
    classe: 'a-sair-em-breve',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.aSairEmBreve'
  },
  [INDICADOR_IDS.ACIMA_DO_LIMITE]: {
    icone: { 
      tipo: 'image', 
      valor: obterSVG('images/fora-janela-limite.svg') 
    },
    classe: 'acima-do-limite',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.realizandoHoraExtraAcimaDoLimiteDefinido'
  },
  [INDICADOR_IDS.EM_HORA_EXTRA]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-horas-extras' 
    },
    classe: 'em-hora-extra',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.emHoraExtra'
  },
  [INDICADOR_IDS.EM_PAUSA]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-pausa' 
    },
    classe: 'em-pausa',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.emPausa'
  },
  [INDICADOR_IDS.ENTRADA_ATRASADA]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-entrada' 
    },
    classe: 'entraram-atrasado',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.entradaAtrasada'
  },
  [INDICADOR_IDS.FERIAS]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-ferias' 
    },
    classe: 'ferias',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.ferias'
  },
  [INDICADOR_IDS.DISPENSA]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-dispensa' 
    },
    classe: 'dispensas',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.dispensas'
  },
  [INDICADOR_IDS.AFASTAMENTO]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-suspensao' 
    },
    classe: 'afastamentos',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.afastamentos'
  },
  [INDICADOR_IDS.FALTA]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-falta' 
    },
    classe: 'faltas',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.faltas'
  },
  [INDICADOR_IDS.JORNADA_ENCERRADA]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-jornada-encerrada' 
    },
    classe: 'jornadas-encerrada',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.jornadaEncerrada'
  },
  [INDICADOR_IDS.FOLGA]: {
    icone: { 
      tipo: 'class', 
      valor: 'icone-linha-folgas-trabalhadas' 
    },
    classe: 'folgas',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.folgas'
  },
  [INDICADOR_IDS.LIMITE_15]: {
    icone: { 
      tipo: 'image', 
      valor: obterSVG('images/dentro-janela-limite-15.svg')
    },
    classe: 'dentro-janela-15',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.dentroJanela15'
  },
  [INDICADOR_IDS.LIMITE_30]: {
    icone: { 
      tipo: 'image', 
      valor: obterSVG('images/dentro-janela-limite-30.svg') 
    },
    classe: 'dentro-janela-30',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.dentroJanela30'
  },
  [INDICADOR_IDS.FORA_DA_JANELA]: {
    icone: { 
      tipo: 'image', 
      valor: obterSVG('images/fora-janela-limite.svg') 
    },
    classe: 'fora-janela',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.foraJanela'
  },
  FALLBACK: {
    icone: { tipo: 'class', valor: 'icone-linha-erro' },
    classe: 'erro',
    legenda: 'acompanhamentoTempoReal.paineis.Legendas.indicadorDesconhecido'
  }
};

export const obterIndicadorMapeado = (indicadorId) => {
  return MAPA_INDICADORES[indicadorId] || MAPA_INDICADORES.FALLBACK;
}
